module.exports = __webpack_public_path__ + "static/media/B_E03.71152ab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/B_E03.png
// module id = 114
// module chunks = 0